<mat-toolbar>
  <h4 mat-dialog-title style="width: 100%"></h4>
  <span class="fill-remaining-space"></span>
  <button class="btn-dialog-close" mat-raised-button (click)="onClose()" tabindex="-1">
    <mat-icon>clear</mat-icon>
  </button>
</mat-toolbar>

<mat-dialog-content>
    <div class="row">
      <div class="col-12">
        <button mat-raised-button style="background-color: var(--app-success); color: white;"
                class="btn btn-success"
                (click)="sendNotification()"
        >Nueva Notificación
        </button>
      </div>
    </div>

    <ng-container *ngIf="loadingNotifications === true">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-container>

    <app-user-notifications-list *ngIf="loadingNotifications === false && notificationsUsr" [userNotifications]="notificationsUsr" [user]="user" (updateList)="loadNotificationsUsr()"></app-user-notifications-list>
</mat-dialog-content>
<hr>
<mat-dialog-actions align="end">
  <button class="btn" mat-stroked-button (click)="onClose()">Cerrar Ventana</button>
</mat-dialog-actions>


